// extracted by mini-css-extract-plugin
module.exports = {"comments":"TenderComments__comments___1TxhU","commentsHeader":"TenderComments__commentsHeader___1m2TZ"};